<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'Auth.ValidateMemberCard' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false">
  <form (ngSubmit)="onFormSubmitted()" novalidate [formGroup]="form">
    <ion-list>
      <ion-item>
        <!-- might want to look at alternative to fix the layout here a bit-->
        <ion-label floating style="min-width: 120px;">
          {{ 'Auth.EnterCardNumber' | translate }}
          @if(formErrors.has('memberCard')) {
            <ion-text color="danger"><br />{{formErrors.has('memberCard')}}</ion-text>
          }
          
        </ion-label>
        <ion-input formControlName="memberCard" type="text" [placeholder]=""> </ion-input>
      </ion-item>

      @if(ResponseFalse) {
        <ion-text color="danger">
          <p class="ion-padding-start ion-no-margin">{{ responseError }}</p>
        </ion-text>
      }
      
    </ion-list>

    <div padding>
      <ion-button type="submit" [disabled]="!form.valid" ion-button color="primary" expand="block">
        {{ 'Auth.Submit' | translate }}
      </ion-button>
    </div>
  </form>
</ion-content>